/*! intention-mobile-fix.js — mobile readability for <intention-journal>
 * CSS + late text polish via MutationObserver. No personalization/order/engine logic.
 */
(function () {
  var CSS = '\n/* Intention Squared — mobile readability fix (injected into open shadow root) */\n.brand-logo-frame{\n  width:min(220px,58vw)!important;\n  height:auto!important;\n  min-height:40px!important;\n  overflow:visible!important;\n  transform:none!important;\n  margin-right:0!important;\n}\n.brand-logo{\n  position:static!important;\n  top:auto!important;\n  left:auto!important;\n  width:100%!important;\n  max-width:220px!important;\n  height:auto!important;\n}\n.brand-title{font-size:15px!important;font-weight:600!important}\n.eyebrow{font-size:12px!important}\n.product-highlights small{font-size:13px!important;max-width:160px!important}\n.cover-style-option>span{font-size:14px!important}\n.marketplace-shell{\n  padding-top:max(12px,env(safe-area-inset-top))!important;\n}\n@media (width<=560px){\n  .product-highlights>span{padding:18px 6px!important}\n  .product-highlights strong{font-size:17px!important}\n  .header-context,.marketplace-breadcrumb{font-size:13px!important}\n  .cover-style-option{padding:10px!important}\n  .cover-style-option>small{font-size:12px!important}\n}\n';

  CSS += '\n.brand-bar,.marketplace-breadcrumb{display:var(--intention-builder-intro-display,flex)!important}\n';

  function polishCopy(root) {
    if (!root) return;
    root.querySelectorAll('details.goal-starters').forEach(function (el) {
      if (el.dataset.intentionStarterReady) return;
      el.dataset.intentionStarterReady = 'true';
      el.open = true;
      var summary = el.querySelector('summary');
      if (summary) summary.textContent = 'Pre-Filled Options';
      var intro = el.querySelector('p');
      if (intro) intro.textContent = 'Choose a ready-made set, review all 24 ideas, and make them yours. Nothing changes until you apply it.';
    });
    root.querySelectorAll('input[placeholder="e.g. MY YEAR²"]').forEach(function (el) {
      el.setAttribute('placeholder', 'e.g. MY NEXT CHAPTER');
    });
    root.querySelectorAll('.brand-title').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (t === 'Bingo Goals') el.textContent = 'Squared';
    });
    root.querySelectorAll('*').forEach(function (el) {
      if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
        var t = el.textContent || '';
        if (t.indexOf('Hover over the cover') !== -1) {
          el.textContent = t
            .replace('Hover over the cover for a closer look', 'Tap the cover for a closer look')
            .replace('Hover over the cover', 'Tap the cover');
        }
      }
    });
  }

  function inject(root) {
    if (!root) return;
    if (!root.getElementById('intention-mobile-fix')) {
      var style = document.createElement('style');
      style.id = 'intention-mobile-fix';
      style.textContent = CSS;
      root.appendChild(style);
    }
    polishCopy(root);
  }

  function watch(root) {
    if (!root || root.__intentionMobileFixWatching) return;
    root.__intentionMobileFixWatching = true;
    var scheduled = null;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = setTimeout(function () {
        scheduled = null;
        polishCopy(root);
      }, 50);
    });
    obs.observe(root, { childList: true, subtree: true, characterData: true });
  }

  function tryInject() {
    var host = document.querySelector('intention-journal');
    if (!host || !host.shadowRoot) return false;
    inject(host.shadowRoot);
    watch(host.shadowRoot);
    return true;
  }

  if (tryInject()) return;
  var pageObs = new MutationObserver(function () {
    if (tryInject()) pageObs.disconnect();
  });
  pageObs.observe(document.documentElement, { childList: true, subtree: true });
  var n = 0;
  var t = setInterval(function () {
    n += 1;
    if (tryInject() || n > 40) clearInterval(t);
  }, 250);
})();

/* Single-choice accessibility enhancement; selection remains owned by React. */
(function () {
  function enhance(root) {
    if (root.__intentionRadioGroups) return;
    root.__intentionRadioGroups = true;
    var selector = '.cover-style-picker, .lettering-picker [aria-label="Journal lettering style"]';
    function sync() {
      root.querySelectorAll(selector).forEach(function (group) {
        group.setAttribute('role', 'radiogroup');
        var buttons = Array.from(group.querySelectorAll('button'));
        buttons.forEach(function (button) {
          var selected = button.classList.contains('cover-style-active') || button.classList.contains('lettering-option-active');
          button.setAttribute('role', 'radio');
          button.setAttribute('aria-checked', String(selected));
          button.removeAttribute('aria-pressed');
          button.tabIndex = selected ? 0 : -1;
        });
      });
    }
    root.addEventListener('keydown', function (event) {
      var button = event.target.closest && event.target.closest('button[role="radio"]');
      var group = button && button.closest(selector);
      if (!group) return;
      var buttons = Array.from(group.querySelectorAll('button')).filter(function (item) { return !item.disabled; });
      var index = buttons.indexOf(button);
      if (index < 0) return;
      var next;
      switch (event.key) {
        case 'ArrowRight': case 'ArrowDown': next = (index + 1) % buttons.length; break;
        case 'ArrowLeft': case 'ArrowUp': next = (index + buttons.length - 1) % buttons.length; break;
        case 'Home': next = 0; break;
        case 'End': next = buttons.length - 1; break;
        default: return;
      }
      event.preventDefault();
      buttons[next].focus();
      buttons[next].click();
    });
    // Observe React's selection classes and mounted steps, not our own ARIA writes.
    new MutationObserver(sync).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-pressed'] });
    sync();
  }
  function find() {
    var host = document.querySelector('intention-journal');
    if (!host || !host.shadowRoot) return false;
    enhance(host.shadowRoot);
    return true;
  }
  if (find()) return;
  var observer = new MutationObserver(function () { if (find()) observer.disconnect(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    if (find() || attempts >= 40) { clearInterval(timer); observer.disconnect(); }
  }, 250);
})();
